'use client';

import { useSyncExternalStore } from 'react';

import {
  subscribeWindowResize,
  useHasMounted,
} from './viewport-subscription.utils';

/**
 * Hook to detect desktop screen size - client-side only to prevent hydration issues
 * @param breakpoint The minimum width in pixels to consider desktop (default: 1000)
 * @param minHeight Optional minimum height in pixels; when set, both width and height must pass
 * @returns object with isDesktop boolean and mounted boolean for hydration safety
 */
export function useIsDesktop(
  breakpoint = 1000,
  minHeight?: number
): {
  isDesktop: boolean;
  mounted: boolean;
} {
  const getIsDesktop = () => {
    const widthOk = window.innerWidth >= breakpoint;
    const heightOk = minHeight === undefined || window.innerHeight >= minHeight;
    return widthOk && heightOk;
  };

  const isDesktop = useSyncExternalStore(
    subscribeWindowResize,
    getIsDesktop,
    () => false
  );

  const mounted = useHasMounted();

  return { isDesktop, mounted };
}
